module.exports = new __parcel__URL__("57x34.65d64124.webp").toString();